import React from 'react';
import {Button, Flex} from '@priority-software/priority-style-react';

import {getLocalizedText, texts} from '../../../constants/TextConst';
import styles from '../styles.module.scss';

interface Props {
    onSave(): void;
    onCancel(): void;
}

export const Footer = ({onSave, onCancel}: Props) => (
    <Flex justifyContent="flex-start" componentClasses={styles.footer}>
        <Button skin="primary" onClick={onSave}>
            {getLocalizedText(texts.AddRemarksSave)}
        </Button>
        <Button skin="secondary" onClick={onCancel}>
            {getLocalizedText(texts.AddRemarksCancel)}
        </Button>
    </Flex>
);
